import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
const _excluded = ["bordered", "partnerType", "size", "tier"];
import { Image } from 'foundations-components/transitional/components/Image';
import { useMemo } from 'react';
// @ts-ignore svgs are untyped modules
import diamondTierBorderedIconUrl from 'bender-url!marketplace-ui-details/img/diamond-tier-icon-bordered.svg';
// @ts-ignore svgs are untyped modules
import diamondTierIconUrl from 'bender-url!marketplace-ui-details/img/diamond-tier-icon.svg';
// @ts-ignore svgs are untyped modules
import eliteTierBorderedIconUrl from 'bender-url!marketplace-ui-details/img/elite-tier-icon-bordered.svg';
// @ts-ignore svgs are untyped modules
import eliteTierIconUrl from 'bender-url!marketplace-ui-details/img/elite-tier-icon.svg';
// @ts-ignore svgs are untyped modules
import goldTierBorderedIconUrl from 'bender-url!marketplace-ui-details/img/gold-tier-icon-bordered.svg';
// @ts-ignore svgs are untyped modules
import goldTierIconUrl from 'bender-url!marketplace-ui-details/img/gold-tier-icon.svg';
// @ts-ignore svgs are untyped modules
import platinumTierBorderedIconUrl from 'bender-url!marketplace-ui-details/img/platinum-tier-icon-bordered.svg';
// @ts-ignore svgs are untyped modules
import platinumTierIconUrl from 'bender-url!marketplace-ui-details/img/platinum-tier-icon.svg';
// @ts-ignore svgs are untyped modules
import solutionsPartnerBorderedIconUrl from 'bender-url!marketplace-ui-details/img/solutions-partner-icon-bordered.svg';
// @ts-ignore svgs are untyped modules
import solutionsPartnerIconUrl from 'bender-url!marketplace-ui-details/img/solutions-partner-icon.svg';
// @ts-ignore svgs are untyped modules
import solutionsProviderBorderedIconUrl from 'bender-url!marketplace-ui-details/img/solutions-provider-icon-bordered.svg';
// @ts-ignore svgs are untyped modules
import solutionsProviderIconUrl from 'bender-url!marketplace-ui-details/img/solutions-provider-icon.svg';
import { jsx as _jsx } from "react/jsx-runtime";
const PARTNER_TIER_ICONS = {
  elite: [eliteTierIconUrl, eliteTierBorderedIconUrl],
  diamond: [diamondTierIconUrl, diamondTierBorderedIconUrl],
  platinum: [platinumTierIconUrl, platinumTierBorderedIconUrl],
  gold: [goldTierIconUrl, goldTierBorderedIconUrl],
  none: [solutionsPartnerIconUrl, solutionsPartnerBorderedIconUrl]
};
const SOLUTIONS_PROVIDER_ICONS = [solutionsProviderIconUrl, solutionsProviderBorderedIconUrl];
const ICON_SIZES = {
  small: 16,
  medium: 32,
  large: 48
};
export function SolutionsPartnerTierIcon(_ref) {
  let {
      bordered,
      partnerType,
      size,
      tier
    } = _ref,
    rest = _objectWithoutPropertiesLoose(_ref, _excluded);
  const computedIconSize = useMemo(() => {
    if (size && Object.prototype.hasOwnProperty.call(ICON_SIZES, size)) {
      return ICON_SIZES[size];
    }
    return size;
  }, [size]);
  const computedIconUrl = useMemo(() => {
    let iconUrl;
    let borderedIconUrl;
    switch (partnerType) {
      case 'partner':
      case 'reseller':
        {
          [iconUrl, borderedIconUrl] = PARTNER_TIER_ICONS[tier || 'none'];
          break;
        }
      case 'provider':
        {
          [iconUrl, borderedIconUrl] = SOLUTIONS_PROVIDER_ICONS;
          break;
        }
      default:
        return null;
    }
    return bordered ? borderedIconUrl : iconUrl;
  }, [bordered, partnerType, tier]);
  if (!computedIconUrl) {
    return null;
  }
  return /*#__PURE__*/_jsx(Image, Object.assign({}, rest, {
    role: "presentation",
    responsive: false,
    objectFit: "contain",
    src: computedIconUrl,
    inlineSize: `${computedIconSize}px`
  }));
}